<template>
  <div id="content">
    <v-card class="justify-center">
      <v-card-title>
        Voorkeur perrons
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="preferredQuays"
        :search="search"
        hide-default-footer
        :items-per-page="1000"
        @click:row="edit"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small v-on:click.stop="deleteQuay(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="secondary" fixed bottom right fab @click="newQuay">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Maak nieuw voorkeurperron</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="preferred_quay_creation" v-model="valid">
            <v-container>
              <span class=".subtitle-1">Lijn + richting</span>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    :items="['ARR', 'EBS', 'CXX', 'SYNTUS', 'HTM', 'GVB', 'RET', 'KEOLIS', 'QBUZZ', 'NS']"
                    label="DataOwnerCode"
                    :rules="[v => !!v || 'DataOwnerCode is verplicht.']"
                    v-model="dataownercode"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    label="LinePlanningNumber"
                    hint="zoals in KV1"
                    required
                    :rules="[v => !!v || 'LinePlanningNumber is verplicht.']"
                    v-model="lineplanningnumber"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    :items="[1, 2]"
                    label="LineDirection"
                    :rules="[v => !!v || 'LineDirection is verplicht']"
                    hint="zoals in KV1"
                    required
                    v-model="linedirection"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="preferredQuay"
                    :items="availableQuays"
                    :menu-props="{ maxHeight: '400' }"
                    label="Voorkeurperron"
                    hint="Kies het standaard perron waarvan deze bus vertrkt."
                    chips
                    persistent-hint
                    :rules="[v => !!v || 'Selecteer een perron.']"
                    required
                  ></v-select>

                  <!-- <v-text-field
                    label="Voorkeurperron"
                    required
                    :rules="[v => !!v || 'Voorkeurperrons is verplicht']"
                    v-model="preferredQuay"
                  ></v-text-field> -->
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuleer</v-btn>
          <v-btn color="blue darken-1" text @click="savePreferredQuay">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "DataOwnerCode",
          align: "start",
          sortable: false,
          value: "dataownercode"
        },
        { text: "LinePlanningNumber", value: "lineplanningnumber" },
        { text: "LineDirection", value: "linedirection" },
        { text: "Voorkeur Perron", value: "sidecode" },
        { text: "", value: "actions", sortable: false }
      ],
      preferredQuays: [],
      preferredQuay: false,
      lineplanningnumber: null,
      linedirection: null,
      dataownercode: null,
      dialog: false,
      valid: false,
      editing: false,
      prefferedQuayId: null,
      availableQuays: [
        {value: "NL:Q:54447710", text: "A"},
        {value: "NL:Q:54447610", text: "B"},
        {value: "NL:Q:54447510", text: "C"},
        {value: "NL:Q:54447410", text: "D"},
        {value: "NL:Q:54447310", text: "E"},
        {value: "NL:Q:54447210", text: "F"},
        {value: "NL:Q:54447110", text: "G"},
        {value: "NL:Q:54447000", text: "H"}
      ],
    };
  },
  mounted() {
    this.loadPreferedQuays();
  },
  methods: {
    loadPreferedQuays () {
      this.$http.get("/preferred_quays").then(response => {
        this.preferredQuays = response.data;
      });
    },
    savePreferredQuay: function(event) {
      this.$refs.preferred_quay_creation.validate();
      if (this.valid) {
        if (this.editing) {
          this.editPreferredQuay(event);
        } else {
          this.createPreferredQuay(event);
        }
        // This is uggly but it's the easiest way to get it working.
        this.loadPreferedQuays();
        this.dialog = false;
      }
    },
    createPreferredQuay: function(event) {
      this.$http
        .post("/preferred_quay", {
          dataownercode: this.dataownercode,
          lineplanningnumber: this.lineplanningnumber,
          linedirection: this.linedirection,
          quaycode: this.preferredQuay,
          stopplacecode: "NL:S:54447000"
        })
        .then(response => {
          this.preferredQuays.push(response.data);
        });
    },
    editPreferredQuay: function(event) {
      this.$http
        .patch("/preferred_quay", {
          id: this.preferredQuayId,
          dataownercode: this.dataownercode,
          lineplanningnumber: this.lineplanningnumber,
          linedirection: this.linedirection,
          quaycode: this.preferredQuay,
          stopplacecode: "NL:S:54447000"
        })
        .then(response => {
          const replaceIndex = this.preferredQuays.findIndex(item => {
            return item.id == this.preferredQuayId;
          });
          this.preferredQuays.splice(replaceIndex, 1, response.data);
        });
    },
    deleteQuay: function(event) {
      this.$http
        .delete("/preferred_quay/" + event.id)
        .then(response => {
          const index = this.preferredQuays.indexOf(event);
          this.preferredQuays.splice(index, 1);
        });
    },
    edit: function(event) {
      this.editing = true;
      this.dialog = true;
      this.preferredQuayId = event.id;
      this.dataownercode = event.dataownercode;
      this.lineplanningnumber = event.lineplanningnumber;
      this.linedirection = event.linedirection;
      this.preferredQuay = event.quaycode;
    },
    newQuay: function(event) {
      this.editing = false;
      this.dialog = true;
      this.preferredQuayId = null;
      this.dataownercode = null;
      this.lineplanningnumber = null;
      this.linedirection = null;
      this.preferredQuay = null;
    }
  }
};
</script>

<style scoped>
#content {
  max-width: 1000px;
  align-content: center;
}
</style>
